import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit';
import notifySlice from './notifyReducer';
import userSlice from './userReducer';
import cardSlice from './cardReducer';
import pageSlice from './pageReducer';

export const store = configureStore({
  reducer: {
    notify: notifySlice,
    card: cardSlice,
    page: pageSlice,
    user: userSlice
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false
    })
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<ReturnType, RootState, unknown, Action<string>>;
